import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { ProductLine } from '@adc/constants';
const ApplicationThemeContext = createContext({
    productLine: ProductLine.AuctionCom,
    version: 1,
});
const ApplicationThemeConsumer = ApplicationThemeContext.Consumer;
const ApplicationThemeProvider = ({ children, theme: _theme, }) => {
    const theme = useMemo(() => ({
        ...{ productLine: ProductLine.AuctionCom, version: 1 },
        ..._theme,
    }), [_theme]);
    return (_jsx(ApplicationThemeContext.Provider, { value: theme, children: children }));
};
const useApplicationTheme = () => {
    const context = useContext(ApplicationThemeContext);
    return context;
};
const withApplicationTheme = (Component) => (props) => (_jsx(ApplicationThemeConsumer, { children: theme => _jsx(Component, { theme: theme, ...props }) }));
export { ApplicationThemeProvider, ApplicationThemeConsumer, useApplicationTheme, withApplicationTheme, ProductLine, };
//# sourceMappingURL=index.js.map